import React, { useState, } from 'react';

import connect from "react-redux/es/connect/connect";

import SearchInputs from "../../components/common/SearchInputs";
import Pagination from './pagination';
import { MenuItem, Select, Accordion, AccordionSummary, AccordionDetails, Typography, RadioGroup, FormControlLabel, Radio, FormLabel } from "@material-ui/core"
import { ExpandMore } from "@material-ui/icons";
import { CustomDatePicker } from "../../components/common/CustomDatePicker";

import "./style.css";

function Search({ languages, curLang, vocabularies, searchFields }) {

  const [searchValue, setSearchValue] = useState('');
  const [selectedFromDate, setSearchFromDate] = useState('');
  const [selectedToDate, setSearchToDate] = useState('');
  const [selectedLang, setSelectedLang] = useState(languages[2] && languages[2].type);
  const [selectedSearchType, setSelectedSearchType] = useState('');
  const [selectedSearchField, setSelectedSearchField] = useState((searchFields && searchFields[9] && searchFields[9].value) || "all");
  const [selectedSearchMode, setSelectedSearchMode] = useState('normal');
  const [clicked, setClicked] = useState(0);
  const [clickedSearch, setClickedSearch] = useState(false);
  const [reset, setReset] = useState(false);
  const [renderResults, setRenderResults] = useState(false);


  const [dobEnable, setRange] = useState(false);
  const [accordionExpanded, setAccordionExpanded] = useState(false);

  const handleChangeSearchFields = e => {
    if (e.target.value && e.target.value === "DOB") {
      setRange(true);
    } else {
      setRange(false);
    }
    setSelectedSearchField(e.target.value)
  };


  const handleFromDate = e => {
    setSearchFromDate(e.target.value);
  };

  const handleToDate = e => {
    setSearchToDate(e.target.value);
  };


  const handleLanguage = e => {
    setSelectedLang(e.target.value);
  };

  const handleSearchMode = e => {
    setSelectedSearchMode(e.target.value);
  };

  const handleSearchType = e => {
    setSelectedSearchType(e.target.value);
  };

  const onSubmit = (e) => {
    setRenderResults(true);
    if (clickedSearch) {
      setClicked(clicked + 1);
    }
    else {
      setClickedSearch(true);
    }
    e.preventDefault();
  }

  const handleAccordianExpanded = e => {
    setAccordionExpanded((prev) => !prev);
  };

  return (
    <div className="search-container">
      <div className="search-top">
        <form>
          <div className='lang-container'>
              <FormLabel id='language'>{vocabularies[curLang]['search']['searchFormTitle']}</FormLabel>
          </div>
          <SearchInputs
            text="Text to be replaced"
            subText="Subtitle to show number of searches overtime"
            languages={languages}
            searchFields={searchFields}
            handleChangeInput={({ target: { value } }) => { setSearchValue(value); }}
            onClick={onSubmit}
            onReset={() => {
              setClickedSearch(false);
              setClicked(0);
              setReset(true);
              setSearchValue("");
              setRenderResults(false);
              setSearchFromDate(null);
              setSearchToDate(null);
              setSelectedLang(languages && languages[2] && languages[2].type);
              setSelectedSearchField((searchFields[9] && searchFields[9].value) || "all");
              setSelectedSearchMode("normal");
            }}
            inputValue={(reset) ? searchValue : undefined}
            curLang={curLang}
            vocabularies={vocabularies}
            searchValue={searchValue}
          />
          <div className='search-dropdowns'>
            <div className="lang-container">
              <FormLabel id="language">{vocabularies[curLang]['search']['language']}:</FormLabel>
              {languages && languages.length ?
                <Select
                  aria-labelledby="language"
                  className="lang"
                  value={selectedLang}
                  onChange={handleLanguage}
                >
                  {languages.map((lang) => (
                    <MenuItem value={lang.type} key={lang.type}>
                      {lang.name}
                    </MenuItem>
                  ))}
                </Select>
                :
                null
              }
            </div>
            <div className="field-container">
              <FormLabel id="searchFields">{vocabularies[curLang]['search']['searchOn']}:</FormLabel>
              {searchFields && searchFields.length ?
                <Select
                  aria-labelledby="searchFields"
                  className="fields"
                  value={selectedSearchField}
                  onChange={handleChangeSearchFields}
                  inputProps={{
                    value: selectedSearchField
                  }}
                >
                  {searchFields.map((lang) => (
                    <MenuItem value={lang.value} key={lang.value}>
                      {lang.name}
                    </MenuItem>
                  ))}
                </Select>
                :
                null
              }
            </div>
          </div>


          <div className="advanced-search">
            <Accordion className={accordionExpanded ?  "advanced-search-container" : "accordionSummary" }
                       expanded={accordionExpanded}
                       onChange={handleAccordianExpanded}>
              <AccordionSummary
                className="advanced-search-container"
                expandIcon={<ExpandMore />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className='advanced-search-head'>{vocabularies[curLang]['search']['advancedSearch']}</Typography>
              </AccordionSummary>
              <AccordionDetails className="advanced-search-details">
                <div>
                  <FormLabel id="searchMode">{vocabularies[curLang]['search']['dateOfBirth']}</FormLabel>
                </div>
                <div className="dateRange">
                  <div className="fromDate">
                    <CustomDatePicker value={selectedFromDate} label={vocabularies[curLang]['search']['from']}
                      maxDate={selectedToDate}
                      className="dateRangeFields" onChange={handleFromDate} />
                  </div>
                  <div className="toDate">
                    <CustomDatePicker value={selectedToDate} label={vocabularies[curLang]['search']['to']} minDate={selectedFromDate}
                      className="dateRangeFields" onChange={handleToDate} />
                  </div>
                </div>

                <div>
                  <FormLabel id="searchMode">{vocabularies[curLang]['search']['searchMode']}</FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="searchMode"
                    value={selectedSearchMode}
                    name="radio-buttons-group"
                    onChange={handleSearchMode}
                  >
                    <FormControlLabel value="normal" control={<Radio />} label={vocabularies[curLang]['search']['normal']} />
                    <FormControlLabel value="fuzzy" control={<Radio />} label={vocabularies[curLang]['search']['fuzzy']} />
                    <FormControlLabel value="startWith" control={<Radio />} label={vocabularies[curLang]['search']['startWith']} />
                    <FormControlLabel value="endWith" control={<Radio />} label={vocabularies[curLang]['search']['endWith']} />
                    <FormControlLabel value="contains" control={<Radio />} label={vocabularies[curLang]['search']['contains']} />
                  </RadioGroup>
                </div>
                <div className="description">
                  {vocabularies[curLang]['search']['wildcardSearch'].split('\n').map(text => (
                    <div>{text}</div>
                  ))}
                </div>

              </AccordionDetails>
            </Accordion>
          </div>
        </form>
      </div>
      {renderResults ?
        <Pagination
          searchValue={searchValue}
          selectedLang={selectedLang}
          selectedFromDate={selectedFromDate}
          selectedToDate={selectedToDate}
          selectedSearchField={selectedSearchField}
          selectedSearchMode={selectedSearchMode}
          selectedSearchType={selectedSearchType}
          clicked={clicked}
          curLang={curLang}
          vocabularies={vocabularies}
          languages={languages}
        />
        :
        null
      }
    </div>
  )
}

const mapStateToProps = (state) => ({
  languages: state.languages,
  curLang: state.curLang,
  vocabularies: state.vocabularies,
  searchFields: state.searchFields
});

export default (connect(mapStateToProps)(Search));
